import angular from "angular";

angular
    .module('app')
    .component('singleCourseForm', {
        template: require('./single-course-form.html'),
        controller: ['$uibModal', 'Notifier', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($uibModal, Notifier, $http) {

    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.openSale = true;
    $ctrl.cost = 0;
    $ctrl.discountValue = 0;
    $ctrl.onlinePayment = true;
    $ctrl.offlinePayment = false;
    $ctrl.paymentInfo = null;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;

        if ($ctrl.course) {
            let course = $ctrl.course;
            $ctrl.id = course.id;
            $ctrl.openSale = course.open_sale;
            $ctrl.cost = course.cost;
            $ctrl.discountValue = course.discount_value;
            $ctrl.onlinePayment = course.online_payment;
            $ctrl.offlinePayment = course.offline_payment;
            $ctrl.paymentInfo = course.payment_info;
        }

    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            course_id: $ctrl.id,
            open_sale: $ctrl.openSale,
            cost: $ctrl.cost,
            discount_value: $ctrl.discountValue,
            online_payment: $ctrl.onlinePayment,
            offline_payment: $ctrl.offlinePayment,
            payment_info: $ctrl.paymentInfo
        };

        let req = null;

        if ($ctrl.id) {
            params['_method'] = 'PUT';
            req = $http.post(`/admin/courses/${$ctrl.id}/update-single-sale`, params);

            req.then(
                function (response) {
                    $ctrl.loading = false;
                    Notifier.success('Данные успешно обновлены', 2);

                    $ctrl.close({$value: params});
                },
                function (error) {
                    $ctrl.loading = false;
                }
            );
        }


    }
}
